import React, {
  useRef,
  useState,
  useEffect,
  forwardRef,
  useCallback,
  useImperativeHandle,
} from "react";
import SearchPanel from "@widgets/SearchPanel"; // 조회조건 Panel
import { fnGetDataSet, fnSave } from "@shared/api/restApi"; // BackEnd API
import { getInitFormData, getNoSlip } from "@shared/utils/CommonUtils"; // 공통 유틸 메뉴 초기화(조회조건, 그리드, 프리폼) 설정 load 관련 내용
import { showDialog } from "@widgets/CommonDialog"; // Message Box
import { global } from "@shared/libs/Global"; // Login User관련 전역 변수( 로그인 정보)
import SnGrid from "@shared/components/Grid/SnGrid"; // 공통 그리드
import { menuInfo } from "@shared/type/CommonType"; // 공통 Interface

interface Props {
  Menuprops: menuInfo;
}

interface RowData {
  KeyField?: string; // 행의 고유 ID
  [key: string]: any;
}

const SN_PMS_BAS_REG_002 = forwardRef(({ Menuprops }: Props, ref) => {
  //#region  variable
  const { userInfo } = global(); // Login user 정보
  const gridApiRef1 = useRef<any>(null); // 첫 번째  그리드 Reference 변수
  const searchRef = useRef<any>(null);
  let SaveData: any = {};
  const [focusedRowData, setFocusedRowData] = useState<any>();
  //#endregion

  //#region  Components useState
  const [formData, setFormData] = useState<any>(); // 조회조건 변수
  const [formControlData, setFormControlData] = useState<any[]>([]); // 조회조건 설정된 항목 binding
  const [columns1, setColums1] = useState<any[]>([]); // gridApiRef1 컬럼 설정 관련
  const [dataSource1, setDataSource1] = useState<any[]>([]); // gridApiRef1 datasource 관련
  const [isLoading, setIsLoading] = useState(false);
  const [gridFocus, setGridFocus] = useState(false);
  //#endregion

  useEffect(() => {
    const fetchform = async () => {
      setDataSource1([]);
      try {
        const rtn: any = await getInitFormData();
        setFormControlData(rtn.formControlData); // 조회조건 항목 설정
        setFormData(rtn.formData); // 조회조건 초기값
        setColums1(rtn.grid.grid1); // H그리드 항목 설정

        setFormData((prevData: any) => ({
          ...prevData,
          cd_module: Menuprops.cd_module,
        }));
      } catch (error) {}
    };
    fetchform();
  }, []);

  useEffect(() => {
    gridApiRef1.current.selectAndFocusRow(0);
    setGridFocus(false);
  }, [gridFocus]);

  //#region  Button Event
  useImperativeHandle(ref, () => ({
    onSearch,
    onInsert,
    onDelete,
    onSave,
  }));

  const onSearch = async () => {
    const modifiedRows1 = gridApiRef1.current.getChange();
    if (modifiedRows1.modifiedRowcount > 0) {
      const confirm = await showDialog(
        "confirm",
        "수정된 내용이 있습니다. 저장하시겠습니까?"
      );
      if (confirm) {
        await onSave();
      }
    }
    try {
      const params = {
        id: "sn_pms_bas_reg_002_01",
        params: searchRef.current.getFormdata(),
      };
      setFocusedRowData(0);

      setDataSource1([]);
      const data: any = await fnGetDataSet(params);
      setDataSource1(data[0]);
      if (data[0] && data[0].length > 0) {
        await new Promise((resolve) => setTimeout(resolve, 50));
        setGridFocus(true);
      }
      gridApiRef1.current.resetUpdate();
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };

  const onBeforeAddRow1 = (newRow: RowData): boolean => {
    // const selectedFormData = searchRef.current.getFormdata();
    // const selectedData = {
    //   fg_pjt: selectedFormData.fg_pjt,
    // };
    try {
      const updatedRow = {
        cd_firm: userInfo.cd_firm,
        cd_activity: "",
        nm_activity: "",
        fg_pjt: "",
        fg_wbs: "2",
        tp_work: "001",
        fg_work: "000",
        dc_rmk: "",
        yn_use: "Y",
        fg_activity: "",
      };
      Object.assign(newRow, updatedRow); // 원본 객체 수정
      return true;
    } catch (error: any) {
      return false;
    }
  };

  const onInsert = () => {
    try {
      const newRow = {};
      gridApiRef1.current.addRow(newRow);
      setTimeout(() => {
        gridApiRef1.current.api.setFocusedCell(
          gridApiRef1.current.api.getDisplayedRowCount() - 1,
          "cd_activity"
        );
      }, 50);
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };

  const onDelete = async () => {
    try {
      gridApiRef1.current.deleteSelectedRows();
    } catch (error) {}
  };

  const onSave = async () => {
    try {
      gridApiRef1.current.api.stopEditing();
      const requiredValuesCheck = gridApiRef1.current.requiredValuesCheck();
      if (!requiredValuesCheck) {
        return;
      }

      const gridGetChanges = gridApiRef1.current.getChange();
      if (gridGetChanges.modifiedRowcount == 0) {
        await showDialog("alter", "변경된 내용이 없습니다.");
        return;
      }

      SaveData["pms_activity"] = gridApiRef1.current.getChange();
      await fnSave("SN_PMS_BAS_REG_002_SAVE_01", SaveData);
      gridApiRef1.current.resetUpdate();

      SaveData = [];
    } catch (error: any) {}
  };
  //#endregion

  //#region  Event Method
  const onFocusedRowChanged = useCallback(
    (focusedRowData: any | null) => {
      setFocusedRowData(focusedRowData);
    },
    [focusedRowData]
  );
  //#endregion

  //#region  UI
  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
          
        />
      </div>
      <SnGrid
        
        seq={1}
        ref={gridApiRef1}
        columnConfig={columns1}
        rowData={dataSource1}
        isEditable={true}
        rowSelection="single"
        onFocusedRowChanged={onFocusedRowChanged}
        onBeforeAddRow={onBeforeAddRow1}
      />
    </div>
  );
  //#endregion
});
export default SN_PMS_BAS_REG_002;
